import request from '@utils/request';

export function getUserListApi() {
  return request.get('v1/users');
}